import React, { useState } from 'react';
import insuranceData from './insurance-data-documents/InsuranceData-Business_v03a-Images-stock_v03-DocLinks.json';

type InsuranceCategory = {
  id: string;
  title: string;
  description: string;
  benefits: string[];
  example: string;
  imageUrls: {
    url: string;
    altText: string;
  }[];
  jsonDocument: string;
};

const InsuranceLookup_v02: React.FC = () => {
    
  const categories: InsuranceCategory[] = insuranceData.businessServices;

  const [selectedId, setSelectedId] = useState<string>('');
  const [result, setResult] = useState<InsuranceCategory | null>(null);

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const id = event.target.value;
    setSelectedId(id);
    const match = categories.find((item) => item.id === id);
    setResult(match || null);
  };

  return (
    <div style={{ maxWidth: '900px', margin: '2rem auto', padding: '1rem' }}>
      <h2>Insurance Category Lookup v02</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="insuranceDropdown" style={{ marginRight: '1rem', fontWeight: 600 }}>
          Select a category:
        </label>
        <select
          id="insuranceDropdown"
          value={selectedId}
          onChange={handleSelect}
          style={{ padding: '0.5rem', width: '60%' }}
        >
          <option value="">-- Select a category --</option>
          {categories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.title}
            </option>
          ))}
        </select>
      </div>

      {result && (
        <div>
          <h3>{result.title}</h3>
          <p><strong>Description:</strong> {result.description}</p>
          <p><strong>Example:</strong> {result.example}</p>
          <h5>Benefits:</h5>
          <ul>
            {result.benefits.map((benefit, idx) => (
              <li key={idx}>{benefit}</li>
            ))}
          </ul>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginTop: '1rem' }}>
            {result.imageUrls.map((img, idx) => (
              <img
                key={idx}
                src={img.url}
                alt={img.altText}
                style={{ width: '200px', borderRadius: '4px' }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://via.placeholder.com/200?text=No+Image';
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default InsuranceLookup_v02;
